'use strict';

/**
 * Collection for conversation posts
 *
 * @category   Collection
 * @module     community
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Collection = require('base/Colido.Collection');
var ConversationPostModel = require('../models/conversationPost');

var ConversationPostsCollection = Collection.extend({
    api: function() {
        var api = '/community/conversations/posts';

        if (this.conversation) {
            api =  this.conversation.api + '/' + this.conversation.id + '/posts';
        }

        return api;
    },

    getName: function() {
        var name = 'community:conversations:posts';

        if (this.conversation) {
            name =  this.conversation.collection.name + ':' + this.conversation.id + ':posts';
        }

        return name;
    },

    name: 'community:conversations:posts',

    model: ConversationPostModel,

    sortDefault: 'created.desc',

    conversation: null,

    initialize: function(models, options) {
        options = options || {};

        if (!options.conversation) {
            return Colido.config.debug && console.log('You have to provide a conversation model as option when initializing a conversationPost collection');
        }

        this.conversation = options.conversation;

        this.name = this.getName();

        this.applyPatchExtension();

        this.listenTo(App.radio(this.name).vent, 'updated', function(data) {
            this.setFromWebsocket(data, {remove: false});
        }.bind(this));

        this.listenTo(App.radio(this.name).vent, 'removed', function(data) {
            this.remove(data); //data [1,2,3]
        }.bind(this));

        this.listenTo(App.radio(this.name).vent, 'added', function(data) {
            this.add(data);
        }.bind(this));
    },

    /**
     * Override default comparator to order by id, when default comparison is equal
     * @param {Backbone.Model} a Model a
     * @param {Backbone.Model} b Model b
     * @returns {integer}
     */
    comparator: function(a, b) {
        var compare = Collection.prototype.comparator.call(this, a, b);

        if (compare === 0) {
            return parseInt(a.get('id')) < parseInt(b.get('id')) ? -1 : 1;
        } else {
            return compare;
        }
    },
});

module.exports = ConversationPostsCollection;